(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopeeking-bottle"] && !Shopify.designMode) return;
  try {
    
function initBottle(root) {
  if(root.dataset.ready) return;
  root.dataset.ready='true';
  const photos=()=>root.querySelectorAll('.bp-photo');
  const thumbs=root.querySelectorAll('[data-photo]');
  const zoom=root.querySelector('.bp-zoom');
  const syncMedia=()=>{
    photos().forEach(photo=>{
      if(photo.hidden) photo.querySelectorAll('video').forEach(video=>video.pause());
    });
    const active=root.querySelector('.bp-photo:not([hidden])');
    if(zoom) zoom.hidden=!active || active.classList.contains('bp-video');
  };
  syncMedia();
  thumbs.forEach(button=>button.addEventListener('click',()=>{
    photos().forEach(photo=>photo.hidden=photo.id!==button.dataset.photo);
    syncMedia();
    const video=root.querySelector('.bp-photo:not([hidden]) video');
    if(video) video.play()?.catch(()=>{});
    thumbs.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
  }));
  const dialog=root.querySelector('dialog');
  root.querySelector('.bp-zoom')?.addEventListener('click',()=>{
    const source=root.querySelector('.bp-photo:not([hidden]) img');
    if(!source) return;
    const image=dialog.querySelector('img'); image.src=source.currentSrc||source.src; image.alt=source.alt;
    dialog.showModal();
  });
  dialog?.querySelector('.bp-close').addEventListener('click',()=>dialog.close());
  dialog?.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  const track=root.querySelector('.bp-slide-track');
  if(track){
    const arrows=root.querySelectorAll('[data-slide]');
    const sync=()=>arrows.forEach(button=>button.disabled=button.dataset.slide==='-1'?track.scrollLeft<2:track.scrollLeft>=track.scrollWidth-track.clientWidth-2);
    arrows.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.slide)*(track.firstElementChild.getBoundingClientRect().width+20),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));
    track.addEventListener('scroll',sync,{passive:true}); new ResizeObserver(sync).observe(track);sync();
  }
  const picker=root.querySelector('select[name="id"]');
  if(picker){
    const cards=root.querySelector('.bp-variant-grid');
    cards.hidden=false; picker.hidden=true;
    root.querySelector('label[for="'+picker.id+'"]').hidden=true;
    const update=()=>{
      const option=picker.selectedOptions[0];
      root.querySelector('.bp-price').textContent=option.dataset.price;
      const add=root.querySelector('.bp-add');
      add.disabled=option.dataset.available!=='true';
      add.textContent=add.disabled?add.dataset.soldLabel:add.dataset.addLabel;
      cards.querySelectorAll('[data-variant]').forEach(card=>card.setAttribute('aria-pressed',String(card.dataset.variant===picker.value)));
      if(option.dataset.image){
        const box=root.querySelector('.bp-variant-photo');
        const image=document.createElement('img'); image.src=option.dataset.image; image.alt=option.textContent; image.width=1400; image.height=1400;
        box.replaceChildren(image); photos().forEach(photo=>photo.hidden=photo!==box);
        thumbs.forEach(button=>button.setAttribute('aria-pressed','false'));
        syncMedia();
      }
    };
    picker.addEventListener('change',update);
    cards.querySelectorAll('[data-variant]').forEach(card=>card.addEventListener('click',()=>{picker.value=card.dataset.variant;update();}));
  }
}
document.querySelectorAll('.bp-bottle').forEach(initBottle);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.bp-bottle').forEach(initBottle));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopeeking-home"] && !Shopify.designMode) return;
  try {
    
function initShopeekingHome(root){if(root.dataset.initialized)return;root.dataset.initialized='true';const track=root.querySelector('.sh-gallery');if(!track)return;root.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>{track.scrollBy({left:Number(button.dataset.direction)*track.clientWidth*.85,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}));}
document.querySelectorAll('.sh-home').forEach(initShopeekingHome);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.sh-home').forEach(initShopeekingHome));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopeeking-product-gallery"] && !Shopify.designMode) return;
  try {
    
function initShProduct(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const show=id=>{root.querySelectorAll('[data-slide]').forEach(slide=>{slide.hidden=slide.dataset.slide!==id;if(slide.hidden)slide.querySelectorAll('video').forEach(v=>v.pause());});root.querySelectorAll('[data-select-slide]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.selectSlide===id)));};
 root.querySelectorAll('[data-select-slide]').forEach(b=>b.addEventListener('click',()=>show(b.dataset.selectSlide)));
 root.addEventListener('shopify:block:select',e=>{const slide=e.target.closest('[data-slide]');if(slide)show(slide.dataset.slide);});
 const showVariant=id=>{const slide=Array.from(root.querySelectorAll('[data-variant-id]')).find(s=>s.dataset.variantId===id);if(slide)show(slide.dataset.slide);};
 const select=root.querySelector('[data-variant]');if(select){showVariant(select.value);select.addEventListener('change',()=>{const o=select.selectedOptions[0];root.querySelector('[data-price]').textContent=o.dataset.price;const compare=root.querySelector('[data-compare]');compare.textContent=o.dataset.compare;compare.hidden=!o.dataset.compare;const add=root.querySelector('[data-add]');add.disabled=o.dataset.available!=='true';add.textContent=add.disabled?'Niedostępny':'Dodaj do koszyka';showVariant(o.value);const u=new URL(window.location.href);u.searchParams.set('variant',o.value);window.history.replaceState({},'',u);});}
}
document.querySelectorAll('[data-sh-product]').forEach(initShProduct);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-sh-product]').forEach(initShProduct));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopeeking-product-row"] && !Shopify.designMode) return;
  try {
    
function initShRow(root){if(root.dataset.ready)return;root.dataset.ready='true';const t=root.querySelector('.sh-row__track');const buttons=root.querySelectorAll('[data-sh-direction]');const sync=()=>buttons.forEach(b=>b.disabled=Number(b.dataset.shDirection)<0?t.scrollLeft<=2:t.scrollLeft+t.clientWidth>=t.scrollWidth-2);buttons.forEach(b=>b.addEventListener('click',()=>t.scrollBy({left:Number(b.dataset.shDirection)*t.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));t.addEventListener('scroll',sync,{passive:true});new ResizeObserver(sync).observe(t);sync();}
document.querySelectorAll('[data-sh-row]').forEach(initShRow);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-sh-row]').forEach(initShRow));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopeeking-sealer"] && !Shopify.designMode) return;
  try {
    
function initSealer(root) {
  if(root.dataset.ready) return;
  root.dataset.ready='true';
  const photos=()=>root.querySelectorAll('.sp-photo');
  const thumbs=root.querySelectorAll('[data-photo]');
  const zoom=root.querySelector('.sp-zoom');
  const syncMedia=()=>{
    photos().forEach(photo=>{
      if(photo.hidden) photo.querySelectorAll('video').forEach(video=>video.pause());
    });
    const active=root.querySelector('.sp-photo:not([hidden])');
    if(zoom) zoom.hidden=!active || active.classList.contains('sp-video');
  };
  syncMedia();
  thumbs.forEach(button=>button.addEventListener('click',()=>{
    photos().forEach(photo=>photo.hidden=photo.id!==button.dataset.photo);
    syncMedia();
    const video=root.querySelector('.sp-photo:not([hidden]) video');
    if(video) video.play()?.catch(()=>{});
    thumbs.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
  }));
  const dialog=root.querySelector('dialog');
  root.querySelector('.sp-zoom')?.addEventListener('click',()=>{
    const source=root.querySelector('.sp-photo:not([hidden]) img');
    if(!source) return;
    const image=dialog.querySelector('img'); image.src=source.currentSrc||source.src; image.alt=source.alt;
    dialog.showModal();
  });
  dialog?.querySelector('.sp-close').addEventListener('click',()=>dialog.close());
  dialog?.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  const track=root.querySelector('.sp-slide-track');
  if(track){
    const arrows=root.querySelectorAll('[data-slide]');
    const sync=()=>arrows.forEach(button=>button.disabled=button.dataset.slide==='-1'?track.scrollLeft<2:track.scrollLeft>=track.scrollWidth-track.clientWidth-2);
    arrows.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.slide)*(track.firstElementChild.getBoundingClientRect().width+20),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));
    track.addEventListener('scroll',sync,{passive:true}); new ResizeObserver(sync).observe(track);sync();
  }
  const picker=root.querySelector('select[name="id"]');
  if(picker){
    const cards=root.querySelector('.sp-variant-grid');
    cards.hidden=false; picker.hidden=true;
    root.querySelector('label[for="'+picker.id+'"]').hidden=true;
    const update=()=>{
      const option=picker.selectedOptions[0];
      root.querySelector('.sp-price').textContent=option.dataset.price;
      const add=root.querySelector('.sp-add');
      add.disabled=option.dataset.available!=='true';
      add.textContent=add.disabled?add.dataset.soldLabel:add.dataset.addLabel;
      cards.querySelectorAll('[data-variant]').forEach(card=>card.setAttribute('aria-pressed',String(card.dataset.variant===picker.value)));
      if(option.dataset.image){
        const box=root.querySelector('.sp-variant-photo');
        const image=document.createElement('img'); image.src=option.dataset.image; image.alt=option.textContent; image.width=1400; image.height=1400;
        box.replaceChildren(image); photos().forEach(photo=>photo.hidden=photo!==box);
        thumbs.forEach(button=>button.setAttribute('aria-pressed','false'));
        syncMedia();
      }
    };
    picker.addEventListener('change',update);
    cards.querySelectorAll('[data-variant]').forEach(card=>card.addEventListener('click',()=>{picker.value=card.dataset.variant;update();}));
  }
}
document.querySelectorAll('.sp-sealer').forEach(initSealer);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.sp-sealer').forEach(initSealer));

  } catch(e) { console.error(e); }
})();
})();
